import { Provider } from "react-redux";
import { setupStore } from "./store";

const store = setupStore();

// eslint-disable-next-line react/prop-types
export const Providers = ({ children }) => {
  return <Provider store={store}>{children}</Provider>;
};
